import reduceArray from "../../utils/reduceArray";
import {
  FETCH_DISEASE,
  FETCH_DISEASE_FAILED,
  FETCH_DISEASE_SUCCESS,

  FETCH_AFRICA_SUMMARY,
  FETCH_AFRICA_SUMMARY_FAILED,
  FETCH_AFRICA_SUMMARY_SUCCESS,

  FETCH_COUNTRY_DATA,
  FETCH_COUNTRY_DATA_FAILED,
  FETCH_COUNTRY_DATA_SUCCESS,
} from "./types";

export const initialState = {
  fetchingAfricanSummary: false,
  africanSummary: {},
  fetchingDisease: false,
  activeDisease: {},
  diseases: [],
  fetchingCountryDiseaseData: false,
  countryDiseaseMap: {},
};

export const diseaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_DATA: return ({
        ...state,
        fetchingCountryDiseaseData: true,
    });
    case FETCH_COUNTRY_DATA_FAILED: return ({
        ...state,
        fetchingCountryDiseaseData: false
    });
    case FETCH_COUNTRY_DATA_SUCCESS: return ({
        ...state,
        fetchingCountryDiseaseData: false,
        countryDiseaseMap: reduceArray(action?.data, 'country')
    })
    case FETCH_AFRICA_SUMMARY: return ({
        ...state,
        fetchingAfricanSummary: true,
    });
    case FETCH_AFRICA_SUMMARY_FAILED: return ({
        ...state,
        fetchingAfricanSummary: false,
    });
    case FETCH_AFRICA_SUMMARY_SUCCESS: return ({
        ...state,
        fetchingAfricanSummary: false,
        africanSummary: action?.data
    })
    case FETCH_DISEASE:
      return {
        ...state,
        fetchingDisease: true,
      };
    case FETCH_DISEASE_FAILED:
      return {
        ...state,
        fetchingDisease: false,
      };
    case FETCH_DISEASE_SUCCESS:
      return {
        ...state,
        diseases: action?.diseases,
        activeDisease: action?.diseases?.[0],
        fetchingDisease: false,
      };
    default:
      return state;
  }
};
